import { render, staticRenderFns } from "./CampaignsKeywordsGrid.vue?vue&type=template&id=b7d80908&scoped=true"
import script from "./CampaignsKeywordsGrid.vue?vue&type=script&lang=ts"
export * from "./CampaignsKeywordsGrid.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsKeywordsGrid.vue?vue&type=style&index=0&id=b7d80908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d80908",
  null
  
)

export default component.exports